import React from 'react';
import { Heading, PropertyGroup } from '../../components';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './ListingPage.module.css';
import classNames from 'classnames';

const SectionMultiEnumMaybe = props => {
  const {
    heading: _heading,
    options,
    selectedOptions,
    showUnselectedOptions = true,
    showHeading = true,
  } = props;

  const intl = useIntl();
  const heading = intl.formatMessage({ id: _heading });

  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options) {
    return null;
  }

  if (!hasContent) {
    return null;
  }

  return (
    <section className={css.sectionMultiEnum}>
      <PropertyGroup
        id="ListingPage.amenities"
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showUnselectedOptions={showUnselectedOptions}
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;
